// extracted by mini-css-extract-plugin
export default {"flex1":"AppContainer_flex1__OZIhG","map":"AppContainer_map__deCG1","acronym":"AppContainer_acronym__ykX5Q"};